import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { ContentBlock } from '../../components'
import { defaultAppTitle } from '../../config/functions'
import ProjectGrid from './grid'

class ProjectListing extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>{`Work // ${defaultAppTitle}`}</title>
                </Helmet>
                <ContentBlock className="content-block content-block--hero">
                    <h1 className="epsilon u-no-bm">Work</h1>
                    <h2 className="beta u-no-bm">
                        I've been fortunate to work with some awesome clients over the years, ranging from
                        marketing sites right through to multi-million pound e-commerce platforms.
                    </h2>
                </ContentBlock>

                <ProjectGrid pageSize={10} />
            </div>
        )
    }
}

export default ProjectListing


// WEBPACK FOOTER //
// ./src/pages/projects/index.js